// extracted by mini-css-extract-plugin
module.exports = {"contentwrapper":"UserList_contentwrapper__1ePMK"};